import { PaymentStatus } from '../Interfaces/IAccountService';

export const isPaymentMade = (status: PaymentStatus) => {
  if (status === PaymentStatus.Pending || status === PaymentStatus.Created) {
    return null;
  }

  return status === PaymentStatus.Confirmed;
};
